import { render } from "./StockOrder.vue?vue&type=template&id=03e4c186&scoped=true"
import script from "./StockOrder.vue?vue&type=script&lang=js"
export * from "./StockOrder.vue?vue&type=script&lang=js"

import "./StockOrder.vue?vue&type=style&index=0&id=03e4c186&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e4c186"]])

export default __exports__